import { Component, Input, Output, EventEmitter } from '@angular/core';

import { DataManager } from 'techlify-ng';
import { AlertService } from 'techlify-ng';
import { RequestErrorService } from 'techlify-ng';

import { ClientPayment } from './client-payment.model';

/**
 * Controller used to delete a client payment
 * 
 * @author Floyd Kissoon
 * @since 20190603
 */
@Component({
    selector: 'client-payment-delete',
    templateUrl: './client-payment-delete.html'
})
export class ClientPaymentDeleteComponent {
    @Input() payment: ClientPayment;
    @Output() onSave = new EventEmitter<ClientPayment>();
    private isWorking = false;

    constructor(private dataManager: DataManager, private alertService: AlertService,
        private errorHandler: RequestErrorService) { }

    delete() {
        this.isWorking = true;

        this.dataManager.DELETE('api/client-payments/' + this.payment.id).then(
            res => {
                this.onSave.emit(res.item);
                this.alertService.addAlert('Successfully deleted Client Payment', 'success');
                this.isWorking = false;
            },
            error => {
                this.errorHandler.handleError(error);
                this.isWorking = false;
            }
        );
    }
}